import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const authMethods = {
  signup: (
    email,
    password,
    firstName,
    lastName,
    setErrors,
    setToken,
    setMyUser,
    setUserDetails
  ) => {},

  signin: (email, password, setErrors, setMyUser, setUserDetails, userDetails) => {
    axios
      .get(`${baseUrl}/api/client/login/?NameOfUser=${email}&Password=${password}`)
      //   .then(res => res.json())
      .then(
        (result) => {
          sessionStorage.setItem('token', result.data.nameofUser);
          setMyUser(result.data.nameofUser);
          setUserDetails({
            userID: result.data.userID,
            userName: result.data.nameofUser,
            department: result.data.department
          });
          console.log('User logged in', result);
          console.log('User ID in', result.data.userID);
        },
        (error) => {
          // alert('failed')
          // error.message = 'Failed to login, The user name or password provided is incorrect.'
          setErrors((prev) => [...prev, error.message]);
        }
      )
      .catch((err) => {
        setErrors((prev) => [...prev, err.message]);
      });
  },

  signout: (setMyUser) => {
    console.log('signing out, signing out');
    sessionStorage.clear();
    setMyUser(null);
    window.location.reload();
  }
};

export default authMethods;
